import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedCardioHeartIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6641 1.84766C15.8859 1.35909 17.2196 1.37892 18.5088 1.9541L18.5098 1.95313C20.9507 3.03699 23.0545 6.13282 22.3682 10.417L22.293 10.835C21.5059 14.8097 18.7889 17.753 16.7188 19.5029L16.7178 19.5029C15.5872 20.4547 14.5084 21.1754 13.7021 21.6621C13.0273 22.0695 12.5241 22.3232 12.3379 22.4092C12.2552 22.459 12.179 22.4805 12.1377 22.4883C12.0676 22.5014 12.0049 22.5 11.9951 22.5C11.9857 22.5 11.9229 22.5014 11.8525 22.4883C11.8108 22.4805 11.7331 22.4593 11.6494 22.4082L11.5459 22.3555C11.4757 22.32 11.3786 22.27 11.2578 22.2061C11.016 22.0781 10.6802 21.8941 10.2783 21.6523C9.4752 21.1691 8.40327 20.4549 7.27246 19.5029L7.27148 19.5029C5.20133 17.753 2.48434 14.8097 1.69727 10.835L1.69629 10.833C0.826 6.36296 2.98516 3.07357 5.47852 1.9541L5.47949 1.9541C6.76918 1.37825 8.10383 1.35883 9.32617 1.84766C10.3382 2.25243 11.2499 2.99596 11.9951 4.01758C12.7403 2.99601 13.652 2.25242 14.6641 1.84766Z",
			fill: "white",
			stroke: "#007AAF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.33325 12.9086L7.83325 12.9086L9.49992 9.27219L11.9999 17.454L15.3333 6.54492L16.9999 12.9086L18.6666 12.9086",
			stroke: "#007AAF",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedCardioHeartIcon);
const Memo = memo(ForwardRef);
export default Memo;
